export default __webpack_public_path__ + "static/media/gallery40.e0eb4889.jpg";